import React from 'react';
import {Box, Typography} from '@mui/material';
import {t} from 'i18next';
import ArrButton from '../../../../common/arr-button/ArrButton';
export interface ClearFilterProps {
  resultCount: number;
  sortLabel: string;
  onClearFilters: () => void;
  showResultCount?: boolean;
  showClearFiltersLink?: boolean;
  showSortLabel?: boolean;
}

const ClearFilter: React.FC<ClearFilterProps> = ({
  resultCount,
  sortLabel,
  onClearFilters,
  showResultCount = true,
  showClearFiltersLink = true,
  showSortLabel = true,
}) => {
  return (
    <Box className="transcript-panel-search-sort-result-label">
      {showResultCount && (
        <Typography
          className="transcript-panel-count-label"
          data-testid="transcript-panel-current-sort-label"
        >
          {t('ai.investigate.transcriptPanel.resultsCount', {
            count: resultCount,
          })}
        </Typography>
      )}
      {showClearFiltersLink && (
        <ArrButton
          variant="text"
          size="small"
          onClick={onClearFilters}
          className="transcript-panel-clear-btn"
          aria-label={t('ai.investigate.transcriptPanel.clearFilters')}
          dataTestId="clear-filters-button"
        >
          {t('ai.investigate.transcriptPanel.clearFilters')}
        </ArrButton>
      )}
      {showSortLabel && (
        <Typography
          className="transcript-panel-sort-label"
          data-testid="clear-filter-sort-label"
        >
          {t('ai.investigate.transcriptPanel.sort')}: {sortLabel}
        </Typography>
      )}
    </Box>
  );
};
export default ClearFilter;
